import { ReactNode } from "react";
import { classNames } from "../../utils/class-names";

interface DotsProps {
  className?: string;
  children?: ReactNode;
}

export function Dots({ className, children }: DotsProps): JSX.Element {
  return <span className={classNames("dots", className)}>{children}</span>;
}
